<!-- Emoji first so the Insert field button keeps the same right edge on fields that have no emoji. -->
@if (groups.length || emojiPicker) {
  <div class="insert-field-row">
    @if (emojiPicker) {
      <button
        #emojiButton
        type="button"
        class="insert-field-btn emoji-btn cta-btn"
        [ngClass]="{ 'is-loading': emojiLoading }"
        [title]="'ck_editor.emoji_button' | transloco"
        [attr.aria-label]="'ck_editor.emoji_button' | transloco"
        (mousedown)="rememberCaret()"
        (click)="toggleEmojiPicker()"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path [attr.d]="emojiIconPath" />
        </svg>
      </button>
    }
    @if (groups.length) {
      <button
        type="button"
        class="insert-field-btn field-btn cta-btn"
        [matMenuTriggerFor]="fieldMenu"
        [matMenuTriggerRestoreFocus]="false"
        (mousedown)="rememberCaret()"
      >
        <span class="sign">+</span>
        <span>{{ label | transloco }}</span>
        <span class="caret" aria-hidden="true"></span>
      </button>
    }
  </div>
}

<mat-menu #fieldMenu="matMenu" class="insert-field-menu">
  @for (group of groups; track group) {
    @if (group.label) {
      <div class="insert-field-group">{{ group.label }}</div>
    }
    @for (placeholder of group.placeholders; track placeholder) {
      <button
        mat-menu-item
        type="button"
        [attr.title]="placeholder.description || null"
        (click)="insertPlaceholder(placeholder)"
      >
        {{ placeholder.label }}
      </button>
    }
  }
</mat-menu>
